import { CircleBarChart } from '@aon/aon-tws-common-ui';
import _ from 'lodash';
import * as React from 'react';
import ContentConstants from '../../../../contentConstants';
import { IParticipationCountsVm } from '../../../../models';

export interface IParticipationMonitorChartProps {
	participationCounts: IParticipationCountsVm;
	includePartialCompletes: boolean;
}

export class ParticipationMonitorChart extends React.PureComponent<IParticipationMonitorChartProps> {
	public render() {
		const { completeCount, partialCompleteCount, invitedCount } = this.props.participationCounts;
		const numerator = this.props.includePartialCompletes ? completeCount + partialCompleteCount : completeCount;
		const score = invitedCount ? Math.round((numerator / invitedCount) * 100) : 0;
		const display = score > 100 ? '>100' : score + '';

		return (
			<CircleBarChart
				size='lg'
				unit='%'
				unitSize='lg'
				value={score > 100 ? 100 : score}
				subtext={ContentConstants.PARTICIPATION_MONITOR_COMPLETION_PERCENTAGE}
				displayValue={display}
			/>
		);
	}
}
